import GreenhouseStandard from './GreenhouseStandard';

export default GreenhouseStandard;
